import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Injectable()
export class RtsWelcomeOverlay {
  public dialogRef: MatDialogRef<any>;

  constructor(public dialog: MatDialog) {}

  public open(component: any, isMobile: boolean): MatDialogRef<any> | void {
    const dialogWidth = isMobile ? '288px' : '584px';
    const dialogHeight = isMobile ? '458px' : '570px';
    if (!this.dialogRef) {
      this.dialogRef = this.dialog.open(component, {
        panelClass: 'rts-welcome-overlay',
        minHeight: dialogHeight,
        width: dialogWidth,
        minWidth: dialogWidth,
        data: { isMobile: isMobile },
      });
    }
  }

  public close(): void {
    this.dialog.closeAll();
  }
}
